import { render, staticRenderFns } from "./Language1.vue?vue&type=template&id=7f289efb&scoped=true"
import script from "./Language1.vue?vue&type=script&lang=js"
export * from "./Language1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f289efb",
  null
  
)

export default component.exports